/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Pull",
  size: 20
}

const SvgPull = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <path d="M6.85 8l2.65 2.6L12.15 8l.7.7L9.5 12 6.15 8.7z" />
    <path fill="none" d="M9.5 11V2M6 5.5H3.5v13h12v-13H13" />
  </Svg>
)

SvgPull.defaultProps = defaultProps
export default SvgPull
